import type { DppEventInput } from '@/data/dpp/types';
import type {
	GTMAddToCartPayload,
	GTMMultiAddToCartPayload,
	GTMPurchasePayload,
} from '@/data/types/GTM';
import { extractPartNumberFather } from '@/data/utils/extractPartNumberFather';

export const dppEventsFromAddToCart = (gtm: GTMAddToCartPayload): DppEventInput[] => {
	const partNumber = gtm.product?.partNumber ?? gtm.selection?.sku?.partNumber;
	return partNumber
		? [{ type: 'add_to_cart', partNumber: extractPartNumberFather(partNumber) }]
		: [];
};

export const dppEventsFromMultiAddToCart = (gtm: GTMMultiAddToCartPayload): DppEventInput[] =>
	gtm.products
		.filter(({ partNumber }) => Boolean(partNumber))
		.map(({ partNumber }) => ({
			type: 'add_to_cart' as const,
			partNumber: extractPartNumberFather(partNumber || ''),
		}));

export const dppEventsFromPurchase = (gtm: GTMPurchasePayload): DppEventInput[] =>
	(gtm.cart?.orderItem ?? [])
		.filter(({ partNumber }) => Boolean(partNumber))
		.map(({ partNumber }) => ({
			type: 'purchase_completed' as const,
			partNumber: extractPartNumberFather(partNumber || ''),
		}));
